import { TenantEntity } from '../TenantEntity'
import { queryFilesCount, saveFile } from '@/api/seaExport/file'
import { Company } from '@/class/model/mdm/Company'
import $store from '@/store'
/**
 * 文件VO
 */
export class File extends TenantEntity {
  /**
   * @param {Object} data
   */
  constructor(data) {
    super(data)
    this.className = 'File'
  }
  get isCommodityInspection() {
    return this._data.isCommodityInspection
  }
  set isCommodityInspection(isCommodityInspection) {
    this._data.isCommodityInspection = isCommodityInspection
  }
  get isSpotInspection() {
    return this._data.isSpotInspection
  }
  set isSpotInspection(isSpotInspection) {
    this._data.isSpotInspection = isSpotInspection
  }

  get uuid() {
    return this._data.uuid
  }
  set uuid(uuid) {
    this._data.uuid = uuid
  }
  get version() {
    return this._data.version
  }
  set version(version) {
    this._data.version = version
  }
  get fileId() {
    return this._data.fileId
  }
  set fileId(fileId) {
    this._data.fileId = fileId || 0
  }
  get fileNo() {
    return this._data.fileNo
  }
  set fileNo(fileNo) {
    this._data.fileNo = fileNo
  }
  get jobNo() {
    return this._data.jobNo
  }
  set jobNo(jobNo) {
    this._data.jobNo = jobNo
  }
  get fileType() {
    return this._data.fileType
  }
  set fileType(fileType) {
    this._data.fileType = fileType
  }
  get tax() {
    return this._data.tax
  }
  set tax(tax) {
    this._data.tax = tax || false
  }
  get tenDigitCode() {
    return this._data.tenDigitCode
  }
  set tenDigitCode(tenDigitCode) {
    this._data.tenDigitCode = tenDigitCode
  }
  get companyCname() {
    return this._data.companyCname
  }
  set companyCname(companyCname) {
    this._data.companyCname = companyCname
  }
  get customsBroker() {
    return this._data.customsBroker
  }
  set customsBroker(customsBroker) {
    this._data.customsBroker = customsBroker || 0
  }
  get state() {
    return this._data.state
  }
  set state(state) {
    this._data.state = state || 0
  }
  get expressAddress() {
    return this._data.expressAddress
  }
  set expressAddress(expressAddress) {
    this._data.expressAddress = expressAddress
  }
  get receiveCompany() {
    return this._data.receiveCompany
  }
  set receiveCompany(receiveCompany) {
    this._data.receiveCompany = receiveCompany
  }
  get receivePerson() {
    return this._data.receivePerson
  }
  set receivePerson(receivePerson) {
    this._data.receivePerson = receivePerson
  }
  get receiveTel() {
    return this._data.receiveTel
  }
  set receiveTel(receiveTel) {
    this._data.receiveTel = receiveTel
  }
  get returnExpressNo() {
    return this._data.returnExpressNo
  }
  set returnExpressNo(returnExpressNo) {
    this._data.returnExpressNo = returnExpressNo
  }
  get sendDate() {
    return this._data.sendDate
  }
  set sendDate(sendDate) {
    this._data.sendDate = sendDate
  }
  get backDate() {
    return this._data.backDate
  }
  set backDate(backDate) {
    this._data.backDate = backDate
  }
  get backUser() {
    return this._data.backUser
  }
  set backUser(backUser) {
    this._data.backUser = backUser || 0
  }
  get returnDate() {
    return this._data.returnDate
  }
  set returnDate(returnDate) {
    this._data.returnDate = returnDate
  }
  get returnPerson() {
    return this._data.returnPerson
  }
  set returnPerson(returnPerson) {
    this._data.returnPerson = returnPerson || 0
  }
  get remark() {
    return this._data.remark
  }
  set remark(remark) {
    this._data.remark = remark
  }
  get second() {
    return this._data.second
  }
  set second(second) {
    this._data.second = second || false
  }
  get secondSendDate() {
    return this._data.secondSendDate
  }
  set secondSendDate(secondSendDate) {
    this._data.secondSendDate = secondSendDate
  }
  get secondSendBy() {
    return this._data.secondSendBy
  }
  set secondSendBy(secondSendBy) {
    this._data.secondSendBy = secondSendBy || 0
  }
  get inputBy() {
    return this._data.inputBy
  }
  set inputBy(inputBy) {
    this._data.inputBy = inputBy || 0
  }
  get inputDate() {
    return this._data.inputDate
  }
  set inputDate(inputDate) {
    this._data.inputDate = inputDate
  }
  get inputByDep() {
    return this._data.inputByDep
  }
  set inputByDep(inputByDep) {
    this._data.inputByDep = inputByDep || 0
  }
  get branchId() {
    return this._data.branchId
  }
  set branchId(branchId) {
    this._data.branchId = branchId || 0
  }
  get receiveDate() {
    return this._data.receiveDate
  }
  set receiveDate(receiveDate) {
    this._data.receiveDate = receiveDate
  }
  get sendExpressAddress() {
    return this._data.sendExpressAddress
  }
  set sendExpressAddress(sendExpressAddress) {
    this._data.sendExpressAddress = sendExpressAddress
  }
  get sendReceiveCompany() {
    return this._data.sendReceiveCompany
  }
  set sendReceiveCompany(sendReceiveCompany) {
    this._data.sendReceiveCompany = sendReceiveCompany
  }
  get sendReceivePerson() {
    return this._data.sendReceivePerson
  }
  set sendReceivePerson(sendReceivePerson) {
    this._data.sendReceivePerson = sendReceivePerson
  }
  get sendReceiveTel() {
    return this._data.sendReceiveTel
  }
  set sendReceiveTel(sendReceiveTel) {
    this._data.sendReceiveTel = sendReceiveTel
  }
  get sendExpressNo() {
    return this._data.sendExpressNo
  }
  set sendExpressNo(sendExpressNo) {
    this._data.sendExpressNo = sendExpressNo
  }
  get SendBy() {
    return this._data.SendBy
  }
  set SendBy(SendBy) {
    this._data.SendBy = SendBy || 0
  }
  get customsNo() {
    return this._data.customsNo
  }
  set customsNo(customsNo) {
    this._data.customsNo = customsNo
  }
  get originFileId() {
    return this._data.originFileId
  }
  set originFileId(originFileId) {
    this._data.originFileId = originFileId
  }
  get currentHolder() {
    return this._data.currentHolder
  }
  set currentHolder(currentHolder) {
    this._data.currentHolder = currentHolder || 0
  }
  get prerecordingNo() {
    return this._data.prerecordingNo
  }
  set prerecordingNo(prerecordingNo) {
    this._data.prerecordingNo = prerecordingNo
  }
  get declareDate() {
    return this._data.declareDate
  }
  set declareDate(declareDate) {
    this._data.declareDate = declareDate
  }
  get customsPageNumber() {
    return this._data.customsPageNumber
  }
  set customsPageNumber(customsPageNumber) {
    this._data.customsPageNumber = customsPageNumber || 0
  }
  get customsTransfer() {
    return this._data.customsTransfer
  }
  set customsTransfer(customsTransfer) {
    this._data.customsTransfer = customsTransfer || false
  }
  get tradeMode() {
    return this._data.tradeMode
  }
  set tradeMode(tradeMode) {
    this._data.tradeMode = tradeMode || 0
  }
  get filedUser() {
    return this._data.filedUser
  }
  set filedUser(filedUser) {
    this._data.filedUser = filedUser || 0
  }
  get filedDate() {
    return this._data.filedDate
  }
  set filedDate(filedDate) {
    this._data.filedDate = filedDate
  }
  get rebatedUser() {
    return this._data.rebatedUser
  }
  set rebatedUser(rebatedUser) {
    this._data.rebatedUser = rebatedUser || 0
  }
  get rebatedDate() {
    return this._data.rebatedDate
  }
  set rebatedDate(rebatedDate) {
    this._data.rebatedDate = rebatedDate
  }
  get returnedUser() {
    return this._data.returnedUser
  }
  set returnedUser(returnedUser) {
    this._data.returnedUser = returnedUser || 0
  }
  get returnedDate() {
    return this._data.returnedDate
  }
  set returnedDate(returnedDate) {
    this._data.returnedDate = returnedDate
  }
  get acceptedUser() {
    return this._data.acceptedUser
  }
  set acceptedUser(acceptedUser) {
    this._data.acceptedUser = acceptedUser || 0
  }
  get acceptedDate() {
    return this._data.acceptedDate
  }
  set acceptedDate(acceptedDate) {
    this._data.acceptedDate = acceptedDate
  }
  get jobUuid() {
    return this._data.jobUuid
  }
  set jobUuid(jobUuid) {
    this._data.jobUuid = jobUuid
  }
  static async queryFilesCount({ jobNo, fileNo }) {
    return await queryFilesCount({ jobNo, fileNo }).then(res => res.data)
  }

  /**
   * 创建空对象
   */
  static async createFileByJob(job) {
    const newobj = new File().fillDefaultValue()
    newobj.jobUuid = job.uuid
    newobj.jobNo = job.jobNo
    newobj.tenDigitCode = ''
    newobj.companyCName = ''
    newobj.fileNo = ''
    newobj.customsBroker = 0
    newobj.receivePerson = ''
    newobj.receiveTel = ''
    const customer = await Company.getCompanyById(job.customerId)
    let contact = null
    if (customer != null) {
      newobj.receiveCompany = customer.chineseName
      newobj.expressAddress = customer.address

      const contacts = await new Company(customer).getContacts()
      if (contacts) {
        for (const c of contacts) {
          if (c.contactPerson == job.customerContact) {
            contact = c
            break
          }
        }
        if (!contact) {
          for (const ct of contacts) {
            if (ct.defaultContact) {
              contact = ct
              break
            }
          }
        }
      }
    } else {
      newobj.receiveCompany = ''
      newobj.expressAddress = ''
    }
    if (contact) {
      newobj.receivePerson = contact.contactPerson
      newobj.receiveTel = contact.telephone
    }
    newobj.receiveDate = new Date()
    newobj.tax = false
    newobj.remark = ''
    newobj.inputBy = $store.getters.userId
    newobj.inputDate = new Date()
    newobj.branchId = $store.getters.currentOfficeId
    newobj.inputByDep = $store.getters.currentDeptId
    return newobj
  }

  static async saveFile(file) {
    return await saveFile(file)
  }
}
